import { render } from "./MainView.vue?vue&type=template&id=66ea8ba7&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=66ea8ba7&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ea8ba7"]])

export default __exports__